export const metricType = {
    COUNT: "count",
    TIME: "time"
};

export const ledControllerColorOrder = {
    RGB: "RGB",
    RBG: "RBG",
    BRG: "BRG",
    BGR: "BGR",
    GBR: "GBR",
    GRB: "GRB",
};



// WEBPACK FOOTER //
// ./src/components/util/enums.js